import { Box, BoxProps, Icon, LoaderNew, SpacerNew, TextNew, TextNewProps } from '@jfs/ui-new'
import React from 'react'
import { useLazyApiData, useStores } from '../../../data/store'
import { getFormattedAmount } from '../../../util/utill'

interface DotsProps {
  length: number
  currentIndex: number
}

export const Dots: React.FC<DotsProps> = ({ length, currentIndex, splittedTnxs }) => {
  const { splittedTnxResponses } = useStores((store) => ({
    splittedTnxResponses: store.transactionDetails?.splittedTnxResponses,
    length: store.transactionDetails?.splittedTnxResponses?.length,
  }))

  const getTnxResponseForAIndex = (index) =>
    splittedTnxResponses.find((splittedTnxResponse) => splittedTnxResponse?.index === index)

  return (
    <Box {...styles.dotsContainer}>
      {Array.from({ length }).map((_, index) => (
        <Dot
          tnxData={getTnxResponseForAIndex(index)}
          index={index}
          currentIndex={currentIndex}
          transactionAmount={splittedTnxs?.[index]?.amount}
        />
      ))}
    </Box>
  )
}

const Dot = ({ tnxData, index, currentIndex, transactionAmount }) => {
  const { fetchRemittanceStatus } = useStores((store) => ({
    fetchRemittanceStatus: store.transactionDetails?.fetchRemittanceStatus,
  }))
  console.log('tnxData', tnxData?.idempotentKey)
  const [lazyFetchStatus, fetchStatusHandler] = useLazyApiData(fetchRemittanceStatus)

  const getTnxStatus = () => {
    if (index < currentIndex && !tnxData) {
      return 'SKIPPED'
    } else if (index > currentIndex) {
      return 'NONE'
    } else if (index === currentIndex && !tnxData) {
      return 'CURRENT'
    } else {
      const status = tnxData?.responseData?.transactions?.[0]?.status
      console.log('htag tnxData?.responseData', tnxData?.responseData, tnxData?.responseData?.transactions)
      if (tnxData?.isTimeoutError) {
        return 'PENDING'
      }
      return status || 'FAILED'
    }
  }

  const checkStatus = () => {
    if (getTnxStatus() === 'PENDING') {
      lazyFetchStatus(tnxData?.idempotentKey)
    }
  }

  const tnxDetails = {
    NONE: {
      backgroundColor: 'BACKGROUND',
    },
    CURRENT: {
      backgroundColor: 'PRIMARY',
      iconId: 'CIRCLE',
    },
    SKIPPED: {
      backgroundColor: '#E97451' as any,
      iconId: 'EXCLAMATION',
    },
    PENDING: {
      backgroundColor: 'BG_PRIMARY_PENDING',
      iconId: 'ICON_REFRESH',
    },
    FAILED: {
      backgroundColor: 'ERROR',
      iconId: 'STATUS_FAILED',
    },
    SUCCESS: {
      backgroundColor: 'BG_PRIMARY_SUCCESS',
      iconId: 'TICKMARK',
    },
  }

  const tnxInfo = tnxDetails?.[getTnxStatus()]
  console.log('tnxInfo', tnxData, tnxInfo)

  return (
    <>
      <Box flexDirection={'column'} pr={8}>
        <Box key={index} {...styles.dot?.(tnxInfo?.backgroundColor)} onPress={checkStatus}>
          {fetchStatusHandler?.state !== 'pending' && <Icon id={tnxInfo?.iconId} size={16} color="WHITE" />}
          {fetchStatusHandler?.state === 'pending' && <LoaderNew color={'WHITE'} />}
        </Box>
        <SpacerNew size={10} />
        <TextNew {...styles.label}>{getFormattedAmount(transactionAmount)}</TextNew>
      </Box>
    </>
  )
}

const styles = {
  dotsContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: 20,
    overflowX: 'scroll',
  } as BoxProps,
  dot: (backgroundColor) =>
    ({
      width: 24,
      height: 24,
      borderRadius: 20,
      backgroundColor,
      marginHorizontal: 5,
      justifyContent: 'center',
      alignItems: 'center',
    } as BoxProps),
  label: {
    fontSize: 8,
  } as TextNewProps,
}

/*<Box key={index} {...styles.dot(currentIndex === index)}>
          <IconNew id="TICKMARK" size={28} />
        </Box>*/
